import { createContext, useContext } from "react";

/**
 * True while a frame renders as an inline copy inside a conversation reply
 * (`ConversationFrameEmbed`), not as the canvas node itself. Frames use it
 * to drop canvas-only chrome and behavior, such as inline tools, gesture
 * overlays, and edit-controller registration owned by the canvas node.
 */
export const InlineFrameEmbedContext = createContext(false);

export function useInlineFrameEmbed(): boolean {
  return useContext(InlineFrameEmbedContext);
}
